import { useContext } from 'react';
import { Box, Card } from '@mui/material';
import { AdviceContext } from '../../contexts';
import { Loading } from '../components';
import { AdvicesCard } from './componets/advices-card';
import { LESS_ONE, FROM_ONR_TO_TWO, FROM_TWO_TO_THREE, FROM_FOUR_TO_FIVE_TITLE, SIX_AGE_TITLE } from '../../consts/ages';
import { FROM_FOUR_TO_FIVE, SIX_AGE, FROM_FOUR_TO_FIVE_HOT, FROM_FOUR_TO_FIVE_COLD } from '../../consts/adviceAgeFourSix';

export const AdvicesCards = ({ temperature }) => {
    const advices = useContext(AdviceContext);
    const weatherAdv = (temp) => advices.filter(adv => adv.maxT >= temp && temp >= adv.minT);
    const advice = (text) => weatherAdv(temperature).filter(({ age }) => age === text);

    return (
        <>
            {!advices.length ?
                <Loading /> :
                <div className='advices-wrapper'>
                    <h2 className='advices-wrapper_header'>Одяг для дитини:</h2>
                    <Card sx={{ maxWidth: 635, margin: '0 0 16px', backgroundColor: 'rgba(255, 255, 255, 0.9)' }} >
                        {advice('less 1') &&
                            <AdvicesCard title={LESS_ONE} text={advice('less 1')[0].advice} />
                        }
                    </Card>
                    <Card sx={{ maxWidth: 635, margin: '0 0 16px', backgroundColor: 'rgba(255, 255, 255, 0.9)' }} >
                        {advice('from 1 to 2') &&
                            <AdvicesCard title={FROM_ONR_TO_TWO} text={advice('from 1 to 2')[0].advice} />
                        }
                    </Card>
                    <Card sx={{ maxWidth: 635, margin: '0 0 16px', backgroundColor: 'rgba(255, 255, 255, 0.9)' }} >
                        {advice('from 2 to 3') &&
                            <AdvicesCard title={FROM_TWO_TO_THREE} text={advice('from 2 to 3')[0].advice} />
                        }
                    </Card>
                    <Card sx={{ maxWidth: 635, margin: '0 0 16px', backgroundColor: 'rgba(255, 255, 255, 0.9)' }} >
                        <AdvicesCard title={FROM_FOUR_TO_FIVE_TITLE} text={FROM_FOUR_TO_FIVE}
                            textTemp={temperature <= 15 ? FROM_FOUR_TO_FIVE_COLD : FROM_FOUR_TO_FIVE_HOT} />
                    </Card>
                    <Card sx={{ maxWidth: 635, margin: '0 0 16px', backgroundColor: 'rgba(255, 255, 255, 0.9)' }} >
                        <AdvicesCard title={SIX_AGE_TITLE} text={SIX_AGE} />
                    </Card>
                    <Box>
                        <p>*Дані поради являються рекомендаціями. Тільки матір знає, як краще вдягнути своє дитя.</p>
                    </Box>
                </div>
            }
        </>
    )
}